import { useQuery } from "@tanstack/react-query";
import { ORGANISATION_LIST_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

export default function useGetOrganisationById(id: string) {
  const {
    data,
    isLoading,
    error,
    refetch: refetchOrganisationById,
  } = useQuery({
    queryKey: [...ORGANISATION_LIST_QUERY_KEY, id],
    queryFn: () => OrganisationService.getOrganisationById(id),
    enabled: !!id,
  });

  return {
    organisation: data?.data,
    isLoading,
    error,
    refetchOrganisationById,
  };
}
